














//utils
import mixins from '@/utils/mixins';
import { get } from 'vuex-pathify';

// mixins
import proxyable from '@/mixins/proxyable';

//classes & types
import { Module } from '@/models/configurator/module';

import { filter } from 'lodash';

export default mixins(proxyable).extend({
  name: 'ModulePicker',

  props: {
    onlySpareParts: Boolean,
    isArchived: {
      type: Boolean,
      default: null
    }
  },

  computed: {
    modules: get<Module[]>('configuratorModule/modules'),

    filteredModules(): Module[] {
      // if not filtering by onlySpareParts then get all modules
      const allOrSparePartModules = this.modules.filter(module =>
        this.onlySpareParts ? module.is_public : module
      );

      const filterParams: Record<string, boolean> = {
        is_published: true
      };

      if (this.isArchived !== null) {
        filterParams.is_archived = this.isArchived;
      }

      // filter allOrSparePartModules by an object predicate for each key's value
      return filter(allOrSparePartModules, { ...filterParams });
    }
  }
});
